export default {
  mailTo: null,
  brands: [],
  models: [],
  years: [],
  generations: [],
  bodies: [],
  gears: [],
  drives: [],
  engines: [],
  modifications: [],
  colos: [],
  wheels: [],
  states: [],
  pts: [],
  regions: [],
  modification: null,
  fetching: {
    loadMailTo: false,
    loadBrands: false,
    loadModels: false,
    loadYears: false,
    loadGenerations: false,
    loadBodies: false,
    loadGears: false,
    loadDrives: false,
    loadEngines: false,
    loadModifications: false,
    loadColors: false,
    loadWheels: false,
    loadPts: false,
    loadStates: false,
    loadRegions: false,
    loadModification: false,
    loadAppraisal: false,
  },
};
